import React, { useState, useEffect, useCallback, useRef } from 'react';
import { API } from '../context/AuthContext';

const BTCC_REFERRAL_LINK = process.env.REACT_APP_BTCC_REFERRAL_LINK || 'https://www.btcc.com/en-US/register?inviteCode=YQJOZ5&utm_source=kol';

const s = {
  page: { minHeight: '100vh', background: '#faf9f6', color: '#1a1a1a', fontFamily: 'system-ui, -apple-system, sans-serif' },
  nav: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', maxWidth: 880, margin: '0 auto', padding: '24px 24px 0' },
  logo: { fontFamily: 'Georgia, serif', fontSize: 18, color: '#1a1a1a', textDecoration: 'none' },
  logoAccent: { color: '#1a6b4a' },

  gatedNav: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '20px 24px', background: '#0a0a0a', borderBottom: '1px solid rgba(26,107,74,0.25)' },
  gatedNavInner: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', maxWidth: 960, margin: '0 auto', width: '100%' },
  gatedLogo: { fontFamily: 'Georgia, serif', fontSize: 19, color: '#fff', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 8 },
  gatedLogoDot: { width: 8, height: 8, borderRadius: 99, background: '#34d399', display: 'inline-block' },
  logoutBtn: { background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', color: '#c9c9c9', fontSize: 13, fontWeight: 600, cursor: 'pointer', padding: '8px 16px', borderRadius: 8 },

  hero: { maxWidth: 720, margin: '0 auto', padding: '56px 24px 8px', textAlign: 'center' },
  eyebrow: { display: 'inline-block', background: '#e8f5ef', color: '#1a6b4a', fontSize: 12, fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase', padding: '6px 14px', borderRadius: 99, marginBottom: 20 },
  h1: { fontFamily: 'Georgia, serif', fontSize: 44, margin: '0 0 18px', lineHeight: 1.15, letterSpacing: '-0.01em' },
  sub: { color: '#6b6b6b', fontSize: 17, lineHeight: 1.65, margin: '0 auto 32px', maxWidth: 560 },
  ctaRow: { display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap', marginBottom: 14 },
  ctaPrimary: { display: 'inline-flex', alignItems: 'center', gap: 8, background: '#1a6b4a', color: '#fff', padding: '15px 30px', borderRadius: 10, textDecoration: 'none', fontWeight: 600, fontSize: 15, boxShadow: '0 4px 14px rgba(26,107,74,0.28)', transition: 'transform 0.15s, box-shadow 0.15s' },
  ctaSecondary: { display: 'inline-flex', alignItems: 'center', color: '#1a6b4a', padding: '15px 10px', textDecoration: 'none', fontWeight: 600, fontSize: 15 },
  ctaNote: { color: '#9b9b9b', fontSize: 13, margin: '20px 0 0' },

  trustBar: { display: 'flex', justifyContent: 'center', gap: '28px', flexWrap: 'wrap', maxWidth: 720, margin: '36px auto 0', padding: '20px 24px', borderTop: '1px solid #ece9e2', borderBottom: '1px solid #ece9e2' },
  trustItem: { display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: '#4a4a4a', fontWeight: 500 },
  trustDot: { width: 6, height: 6, borderRadius: 99, background: '#1a6b4a', flexShrink: 0 },

  section: { maxWidth: 960, margin: '0 auto', padding: '48px 24px' },
  sectionHead: { display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 20 },
  sectionTitle: { fontFamily: 'Georgia, serif', fontSize: 26, margin: 0 },
  sectionDesc: { color: '#9b9b9b', fontSize: 13, margin: '4px 0 0' },

  card: { background: '#fff', border: '1px solid #ece9e2', borderRadius: 16, padding: '8px 24px', boxShadow: '0 1px 3px rgba(0,0,0,0.03)' },

  darkSection: { background: '#0a0a0a', padding: '56px 0' },
  darkSectionInner: { maxWidth: 960, margin: '0 auto', padding: '0 24px' },
  darkSectionHead: { marginBottom: 24 },
  darkSectionTitle: { fontFamily: 'Georgia, serif', fontSize: 26, margin: 0, color: '#fff' },
  darkSectionDesc: { color: '#8a8a8a', fontSize: 13, margin: '4px 0 0' },

  pnlGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))', gap: 16 },
  pnlCarouselWrap: { position: 'relative' },
  pnlCarousel: { display: 'flex', gap: 16, overflowX: 'auto', overflowY: 'visible', padding: '10px 4px 14px', scrollSnapType: 'x mandatory', WebkitOverflowScrolling: 'touch', scrollbarWidth: 'none', msOverflowStyle: 'none' },
  pnlCarouselItem: { flex: '0 0 230px', scrollSnapAlign: 'start', transition: 'transform 0.2s ease, box-shadow 0.2s ease', borderRadius: 16 },
  carouselArrow: { position: 'absolute', top: '50%', transform: 'translateY(-50%)', zIndex: 2, width: 36, height: 36, borderRadius: '50%', border: '1px solid rgba(255,255,255,0.15)', background: 'rgba(20,20,20,0.9)', color: '#fff', fontSize: 20, lineHeight: 1, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' },
  pnlCard: { position: 'relative', borderRadius: 16, padding: '20px 20px 18px', minHeight: 280, display: 'flex', flexDirection: 'column', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.08)', background: '#000' },
  pnlCardTaken: { border: '2px solid #34d399', boxShadow: '0 0 0 3px rgba(52,211,153,0.15)' },
  pnlCardBg: { position: 'absolute', inset: 0, backgroundImage: 'url(https://ripplevanwinkle.com/twitter-avatar.jpg)', backgroundSize: 'cover', backgroundPosition: 'center 30%', filter: 'brightness(0.32) saturate(0.7)' },
  pnlCardOverlay: { position: 'absolute', inset: 0, background: 'linear-gradient(180deg, rgba(0,0,0,0.92) 0%, rgba(0,0,0,0.85) 35%, rgba(0,0,0,0.78) 60%, rgba(0,0,0,0.95) 100%)' },
  pnlCardContent: { position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', height: '100%' },
  pnlBrand: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 14 },
  pnlBrandAvatar: { width: 20, height: 20, borderRadius: '50%', flexShrink: 0, objectFit: 'cover' },
  pnlBrandName: { color: '#fff', fontSize: 13, fontWeight: 700 },
  pnlSymbolRow: { display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 },
  pnlSymbol: { color: '#fff', fontSize: 22, fontWeight: 800, letterSpacing: '-0.01em' },
  pnlPerpBadge: { fontSize: 10, fontWeight: 700, color: '#c9c9c9', background: 'rgba(255,255,255,0.12)', padding: '2px 7px', borderRadius: 5, textTransform: 'uppercase' },
  pnlMeta: { fontSize: 12, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '0.03em', marginBottom: 14 },
  pnlPercent: { fontSize: 36, fontWeight: 800, lineHeight: 1 },
  pnlPercentLabel: { fontSize: 12, color: '#9b9b9b', marginTop: 4, marginBottom: 'auto' },
  pnlPrices: { fontSize: 12, color: '#c9c9c9', marginTop: 18, lineHeight: 1.9 },
  pnlPriceLabel: { color: '#9b9b9b' },
  pnlDate: { fontSize: 11, color: '#8a8a8a', marginTop: 8 },
  pnlNotes: { fontSize: 12, color: '#c9c9c9', fontStyle: 'italic', marginTop: 10, lineHeight: 1.5 },
  pnlActions: { display: 'flex', gap: 8, marginTop: 16 },
  pnlBtccLink: { flex: 1, textAlign: 'center', fontSize: 12, fontWeight: 700, padding: '9px 10px', borderRadius: 8, background: 'rgba(26,107,74,0.25)', color: '#34d399', textDecoration: 'none', border: '1px solid rgba(26,107,74,0.5)' },
  pnlWatermark: { fontSize: 10, color: '#6b6b6b', marginTop: 12, letterSpacing: '0.03em' },
  takeButton: { fontSize: 12, fontWeight: 700, padding: '9px 12px', borderRadius: 8, border: '1px solid rgba(255,255,255,0.25)', background: 'rgba(0,0,0,0.4)', color: '#e5e5e5', cursor: 'pointer', whiteSpace: 'nowrap' },
  takeButtonActive: { background: '#1a6b4a', color: '#fff', borderColor: '#1a6b4a' },

  emptyState: { padding: '48px 12px', textAlign: 'center', color: '#9b9b9b', fontSize: 14 },
  emptyStateDark: { padding: '48px 12px', textAlign: 'center', color: '#6b6b6b', fontSize: 14, gridColumn: '1 / -1' },

  statsBar: { display: 'flex', gap: 12, flexWrap: 'wrap', marginBottom: 24 },
  statChip: { background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)', borderRadius: 12, padding: '12px 18px', minWidth: 100 },
  statChipLabel: { fontSize: 11, color: '#8a8a8a', textTransform: 'uppercase', letterSpacing: '0.04em', marginBottom: 4 },
  statChipValue: { fontSize: 20, fontWeight: 800, color: '#fff' },

  overallBar: { display: 'flex', gap: 0, flexWrap: 'wrap', marginBottom: 28, background: 'rgba(26,107,74,0.08)', border: '1px solid rgba(26,107,74,0.25)', borderRadius: 16, overflow: 'hidden' },
  overallHero: { flex: '2 1 220px', padding: '24px 28px', borderRight: '1px solid rgba(255,255,255,0.06)', background: 'rgba(26,107,74,0.1)' },
  overallHeroLabel: { fontSize: 12, color: '#9b9b9b', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: 8, fontWeight: 700 },
  overallHeroValue: { fontSize: 44, fontWeight: 800, lineHeight: 1 },
  overallChip: { flex: '1 1 130px', padding: '18px 20px', borderRight: '1px solid rgba(255,255,255,0.06)', display: 'flex', flexDirection: 'column', justifyContent: 'center' },
  overallChipLabel: { fontSize: 11, color: '#8a8a8a', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 6 },
  overallChipValue: { fontSize: 28, fontWeight: 800, color: '#fff' },

  subSectionTitle: { fontFamily: 'Georgia, serif', fontSize: 18, color: '#fff', margin: '0 0 16px' },
  viewHistoryBtn: { background: 'transparent', border: '1px solid rgba(255,255,255,0.15)', color: '#c9c9c9', fontSize: 13, fontWeight: 600, cursor: 'pointer', padding: '10px 20px', borderRadius: 8 },

  unlockWrap: { maxWidth: 560, margin: '56px auto 0' },
  unlockCard: {
    background: '#111',
    border: '1px solid rgba(26,107,74,0.35)',
    borderRadius: 20,
    padding: '36px 32px',
    boxShadow: '0 0 0 1px rgba(255,255,255,0.03), 0 0 50px rgba(26,107,74,0.12)',
    textAlign: 'center',
  },
  unlockEyebrow: { fontSize: 12, fontWeight: 800, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#e0a530', marginBottom: 18 },
  unlockHeading: { fontFamily: 'Georgia, serif', fontSize: 19, color: '#fff', margin: '0 0 16px', lineHeight: 1.4 },
  offerPill: { display: 'inline-block', border: '1px solid rgba(26,107,74,0.5)', borderRadius: 14, padding: '14px 28px', textDecoration: 'none', background: 'rgba(26,107,74,0.08)', transition: 'border-color 0.15s, background 0.15s' },
  offerPillTitle: { color: '#fff', fontWeight: 800, fontSize: 16, marginBottom: 4 },
  offerPillSub: { color: '#e0a530', fontSize: 12, fontWeight: 600 },
  affiliateDisclosure: { fontSize: 11, color: '#6b6b6b', lineHeight: 1.6, margin: '16px 0 28px' },
  divider: { border: 'none', borderTop: '1px solid rgba(255,255,255,0.08)', margin: '0 0 28px' },

  label: { display: 'block', fontSize: 13, fontWeight: 600, color: '#a8a8a8', marginBottom: 6, textAlign: 'left' },
  input: { width: '100%', padding: '13px 14px', borderRadius: 9, border: '1px solid #ddd', fontSize: 15, marginBottom: 14, boxSizing: 'border-box', outline: 'none', transition: 'border-color 0.15s' },
  button: { width: '100%', padding: '14px', borderRadius: 9, border: 'none', background: '#1a6b4a', color: '#fff', fontWeight: 700, fontSize: 15, cursor: 'pointer', transition: 'opacity 0.15s' },
  buttonDisabled: { opacity: 0.5, cursor: 'not-allowed' },
  statusBox: { fontSize: 13, padding: '10px 14px', borderRadius: 8, marginBottom: 14, background: 'rgba(255,255,255,0.06)', color: '#c9c9c9', textAlign: 'left' },
  error: { fontSize: 13, padding: '10px 14px', borderRadius: 8, marginBottom: 14, background: 'rgba(248,113,113,0.12)', color: '#f87171', textAlign: 'left' },
  privacyNote: { fontSize: 12, color: '#6b6b6b', marginTop: 16 },

  gatedHeader: { maxWidth: 720, margin: '0 auto', padding: '32px 24px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },

  footer: { maxWidth: 720, margin: '0 auto', padding: '32px 24px 64px', textAlign: 'center' },
  footerLinks: { fontSize: 13, color: '#9b9b9b', marginBottom: 10 },
  footerLink: { color: '#9b9b9b', textDecoration: 'underline', margin: '0 6px' },
  disclaimer: { fontSize: 12, color: '#b5b5b5', lineHeight: 1.6, maxWidth: 520, margin: '0 auto' },
};

function formatPrice(price) {
  if (price == null || price === '') return '';
  const num = Number(price);
  if (Number.isNaN(num)) return String(price);
  return `$${num.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 8 })}`;
}

function pnlColor(t) {
  if (t.status !== 'closed') return '#e5e5e5';
  if (t.result === 'loss') return '#f87171';
  return '#34d399';
}

// Leverage is free-typed by the trader/admin (e.g. "50" or "5x") — normalize
// it to always show the trailing "x" wherever it's displayed.
function formatLeverage(lev) {
  if (!lev) return '';
  const str = String(lev).trim();
  return /x$/i.test(str) ? str : `${str}x`;
}

// Matches BTCC's own card wording — "Open" prefix only while the position is
// still live; once closed it just reads "Sell · 5x" / "Buy/Long · 5x".
function sideLabel(t) {
  const openPrefix = t.status === 'open' ? 'Open ' : '';
  const verb = t.side === 'short' ? 'Short' : 'Long';
  const action = t.status === 'open' ? verb : (t.side === 'short' ? 'Sell' : 'Buy/Long');
  const lev = t.leverage ? ` · ${formatLeverage(t.leverage)}` : '';
  return `${openPrefix}${action}${lev}`;
}

function pnlDisplay(t) {
  if (t.pnl_percent == null) return t.status === 'closed' ? '—' : 'Open';
  const sign = Number(t.pnl_percent) > 0 ? '+' : '';
  return `${sign}${t.pnl_percent}%`;
}

function fmtDate(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric', year: 'numeric' });
}

function PnlCard({ trade, index, taken, onToggleTake }) {
  return (
    <div style={{ ...s.pnlCard, ...(taken ? s.pnlCardTaken : {}) }}>
      <div className="pnl-card-bg" style={s.pnlCardBg} />
      <div style={s.pnlCardOverlay} />
      <div style={s.pnlCardContent}>
        <div style={s.pnlBrand}>
          <img src="https://ripplevanwinkle.com/twitter-avatar.jpg" alt="" style={s.pnlBrandAvatar} />
          <div style={s.pnlBrandName}>Rip Bull Winkle</div>
        </div>
        <div style={s.pnlSymbolRow}>
          <div style={s.pnlSymbol}>{trade.symbol.replace('/', '')}</div>
          {trade.leverage && <span style={s.pnlPerpBadge}>Perp</span>}
        </div>
        <div style={{ ...s.pnlMeta, color: trade.side === 'short' ? '#f87171' : '#34d399' }}>{sideLabel(trade)}</div>
        <div style={{ ...s.pnlPercent, color: pnlColor(trade) }}>{pnlDisplay(trade)}</div>
        {trade.status === 'closed' && (
          <div style={s.pnlPercentLabel}>{trade.result === 'loss' ? 'Loss' : 'Profit'} (Closed Position)</div>
        )}
        <div style={s.pnlPrices}>
          <div><span style={s.pnlPriceLabel}>Open price&nbsp;&nbsp;</span>{formatPrice(trade.entry_price)}</div>
          {trade.exit_price && <div><span style={s.pnlPriceLabel}>Closing price&nbsp;&nbsp;</span>{formatPrice(trade.exit_price)}</div>}
        </div>
        <div style={s.pnlDate}>
          Entered {fmtDate(trade.entry_date)}{trade.exit_date ? ` · Closed ${fmtDate(trade.exit_date)}` : ''}
        </div>
        {trade.notes && <div style={s.pnlNotes}>&ldquo;{trade.notes}&rdquo;</div>}
        <div style={s.pnlActions}>
          <a href={BTCC_REFERRAL_LINK} target="_blank" rel="noopener noreferrer" style={s.pnlBtccLink}>Take this on BTCC →</a>
          {onToggleTake && (
            <button
              onClick={() => onToggleTake(trade.id)}
              style={{ ...s.takeButton, ...(taken ? s.takeButtonActive : {}) }}
            >
              {taken ? '✓ Taken' : 'Mark taken'}
            </button>
          )}
        </div>
        <div style={s.pnlWatermark}>trades.xrprightnow.com</div>
      </div>
    </div>
  );
}

function PnlGrid({ trades, dark, emptyText, takenIds, onToggleTake }) {
  if (!trades.length) return <div style={dark ? s.emptyStateDark : s.emptyState}>{emptyText}</div>;
  return (
    <div style={s.pnlGrid}>
      {trades.map((t, i) => (
        <PnlCard
          key={t.id || i}
          trade={t}
          index={i}
          taken={takenIds ? takenIds.includes(t.id) : false}
          onToggleTake={onToggleTake}
        />
      ))}
    </div>
  );
}

// Horizontal, swipeable single-row layout — used for the small public
// highlight reel, where a fixed handful of cards benefits from feeling like a
// showcase rather than a browsable list (that's what PnlGrid is for).
function PnlCarousel({ trades, emptyText }) {
  const scrollerRef = useRef(null);
  if (!trades.length) return <div style={s.emptyStateDark}>{emptyText}</div>;

  const scroll = (dir) => {
    scrollerRef.current?.scrollBy({ left: dir * 260, behavior: 'smooth' });
  };

  return (
    <div style={s.pnlCarouselWrap}>
      <button aria-label="Scroll left" onClick={() => scroll(-1)} style={{ ...s.carouselArrow, left: -6 }}>‹</button>
      <div className="pnl-carousel" ref={scrollerRef} style={s.pnlCarousel}>
        {trades.map((t, i) => (
          <div key={t.id || i} className="pnl-carousel-item" style={s.pnlCarouselItem}>
            <PnlCard trade={t} index={i} />
          </div>
        ))}
      </div>
      <button aria-label="Scroll right" onClick={() => scroll(1)} style={{ ...s.carouselArrow, right: -6 }}>›</button>
    </div>
  );
}

// Animates from 0 up to `target` once, on mount — used for the homepage's
// permanent stat numbers so they feel alive without the underlying data
// actually changing.
function useCountUp(target, animate, duration = 1200) {
  const [value, setValue] = useState(animate ? 0 : target);
  useEffect(() => {
    if (!animate) { setValue(target); return; }
    let raf;
    const start = performance.now();
    const tick = (now) => {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3); // ease-out cubic
      setValue(target * eased);
      if (progress < 1) raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, [target, animate, duration]);
  return value;
}

function OverallStatsBar({ stats, animate }) {
  const pnl = useCountUp(stats?.total_pnl_percent || 0, !!animate);
  const total = useCountUp(stats?.total || 0, !!animate);
  const open = useCountUp(stats?.open || 0, !!animate);

  if (!stats || stats.total === 0) return null;
  const plColor = stats.total_pnl_percent > 0 ? '#34d399' : stats.total_pnl_percent < 0 ? '#f87171' : '#fff';
  return (
    <div style={s.overallBar}>
      <div className="tr-overall-hero" style={s.overallHero}>
        <div style={s.overallHeroLabel}>Total P/L</div>
        <div className="tr-overall-hero-value" style={{ ...s.overallHeroValue, color: plColor }}>
          {pnl > 0 ? '+' : ''}{pnl.toFixed(1)}%
        </div>
      </div>
      <div style={s.overallChip}>
        <div style={s.overallChipLabel}>Total Calls</div>
        <div style={s.overallChipValue}>{Math.round(total)}</div>
      </div>
      <div style={{ ...s.overallChip, borderRight: 'none' }}>
        <div style={s.overallChipLabel}>Open Now</div>
        <div style={s.overallChipValue}>{Math.round(open)}</div>
      </div>
    </div>
  );
}

function Footer() {
  return (
    <div style={s.footer}>
      <div style={s.footerLinks}>
        <a href="https://ripplevanwinkle.com" style={s.footerLink}>Rip Bull Winkle</a>·
        <a href="/privacy" style={s.footerLink}>Privacy</a>·
        <a href="/terms" style={s.footerLink}>Terms</a>
      </div>
      <p style={s.disclaimer}>
        Trading crypto involves substantial risk of loss and is not suitable for every investor. Trades shown here are
        for informational purposes only and are not financial advice. Past results don't guarantee future performance.
      </p>
    </div>
  );
}

export default function TradeRoom() {
  const [token, setToken] = useState(() => localStorage.getItem('trade_room_token'));
  const [teaser, setTeaser] = useState([]);
  const [trades, setTrades] = useState([]);
  const [takenIds, setTakenIds] = useState([]);
  const [stats, setStats] = useState(null);
  // Kept as two separate state values on purpose: teaserOverallStats is the
  // permanently frozen homepage strip (from /teaser, sample data only) and
  // gatedOverallStats is the real, live strip shown to logged-in members
  // (from /trades). They must never share state — if a member is logged in
  // (e.g. the admin, while publishing trades) the /trades fetch below would
  // otherwise overwrite the frozen homepage numbers with real ones.
  const [teaserOverallStats, setTeaserOverallStats] = useState(null);
  const [gatedOverallStats, setGatedOverallStats] = useState(null);
  const [showFullHistory, setShowFullHistory] = useState(false);
  const [uid, setUid] = useState('');
  const [uidStatus, setUidStatus] = useState(null); // { status, message }
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [mode, setMode] = useState('unlock'); // 'unlock' | 'login'
  const [notice, setNotice] = useState('');

  useEffect(() => {
    fetch(`${API}/api/trade-room/teaser`)
      .then((r) => r.json())
      .then((d) => {
        setTeaser(d.trades || []);
        setTeaserOverallStats(d.overall_stats || null);
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    if (!token) return;
    fetch(`${API}/api/trade-room/trades`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => {
        if (!r.ok) throw new Error('unauthorized');
        return r.json();
      })
      .then((d) => {
        setTrades(d.trades || []);
        setTakenIds(d.taken_ids || []);
        setStats(d.stats || null);
        setGatedOverallStats(d.overall_stats || null);
      })
      .catch(() => {
        localStorage.removeItem('trade_room_token');
        setToken(null);
      });
  }, [token]);

  const checkUid = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await fetch(`${API}/api/trade-room/verify-uid`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid }),
      });
      const data = await res.json();
      setUidStatus(data);
    } catch {
      setError('Something went wrong checking your UID. Try again.');
    } finally {
      setBusy(false);
    }
  }, [uid]);

  const activate = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await fetch(`${API}/api/trade-room/activate`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ uid, email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Activation failed.');
        return;
      }
      if (data.existingAccount) {
        setPassword('');
        setNotice(data.message);
        setMode('login');
        return;
      }
      localStorage.setItem('trade_room_token', data.token);
      setToken(data.token);
    } catch {
      setError('Something went wrong activating your account. Try again.');
    } finally {
      setBusy(false);
    }
  }, [uid, email, password]);

  const login = useCallback(async (e) => {
    e.preventDefault();
    setError('');
    setBusy(true);
    try {
      const res = await fetch(`${API}/api/trade-room/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || 'Login failed.');
        return;
      }
      localStorage.setItem('trade_room_token', data.token);
      setToken(data.token);
    } catch {
      setError('Something went wrong logging in. Try again.');
    } finally {
      setBusy(false);
    }
  }, [email, password]);

  const logout = () => {
    localStorage.removeItem('trade_room_token');
    setToken(null);
    setTrades([]);
  };

  const toggleTake = useCallback(async (tradeId) => {
    // Optimistic update so the button feels instant.
    setTakenIds((prev) => (prev.includes(tradeId) ? prev.filter((id) => id !== tradeId) : [...prev, tradeId]));
    try {
      const res = await fetch(`${API}/api/trade-room/trades/${tradeId}/take`, {
        method: 'POST',
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      setTakenIds((prev) => (data.taken ? [...new Set([...prev, tradeId])] : prev.filter((id) => id !== tradeId)));
      // Refresh stats to reflect the change.
      fetch(`${API}/api/trade-room/trades`, { headers: { Authorization: `Bearer ${token}` } })
        .then((r) => r.json())
        .then((d) => setStats(d.stats || null))
        .catch(() => {});
    } catch {
      // Revert optimistic update on failure.
      setTakenIds((prev) => (prev.includes(tradeId) ? prev.filter((id) => id !== tradeId) : [...prev, tradeId]));
    }
  }, [token]);

  if (token) {
    return (
      <div style={s.page}>
        <style>{GLOBAL_STYLE}</style>
        <nav className="tr-nav" style={s.gatedNav}>
          <div style={s.gatedNavInner}>
            <a href="/trade-room" style={s.gatedLogo}>
              <span style={s.gatedLogoDot} />
              Trade <span style={s.logoAccent}>Room</span>
            </a>
            <button onClick={logout} style={s.logoutBtn}>Log out</button>
          </div>
        </nav>
        <div style={{ ...s.darkSection, paddingTop: 40 }}>
          <div style={s.darkSectionInner}>
            <div style={s.darkSectionHead}>
              <h2 style={s.darkSectionTitle}>All trades</h2>
              <p style={s.darkSectionDesc}>Every call, open and closed — wins and losses.</p>
            </div>

            <OverallStatsBar stats={gatedOverallStats} />

            {stats && stats.taken > 0 && (
              <div style={s.statsBar}>
                <div style={s.statChip}><div style={s.statChipLabel}>Trades taken</div><div style={s.statChipValue}>{stats.taken}</div></div>
                <div style={s.statChip}><div style={s.statChipLabel}>Win rate</div><div style={s.statChipValue}>{stats.win_rate != null ? `${stats.win_rate.toFixed(0)}%` : '—'}</div></div>
                <div style={s.statChip}><div style={s.statChipLabel}>Your total P/L</div><div style={{ ...s.statChipValue, color: stats.total_pnl_percent > 0 ? '#34d399' : stats.total_pnl_percent < 0 ? '#f87171' : '#fff' }}>{stats.total_pnl_percent > 0 ? '+' : ''}{stats.total_pnl_percent.toFixed(1)}%</div></div>
              </div>
            )}

            {(() => {
              const openTrades = trades.filter((t) => t.status === 'open');
              const closedTrades = trades.filter((t) => t.status === 'closed');
              const HISTORY_LIMIT = 20;
              const visibleClosed = showFullHistory ? closedTrades : closedTrades.slice(0, HISTORY_LIMIT);
              return (
                <>
                  <h3 style={s.subSectionTitle}>Open Positions</h3>
                  <PnlGrid
                    trades={openTrades}
                    dark
                    emptyText="No open positions right now."
                    takenIds={takenIds}
                    onToggleTake={toggleTake}
                  />

                  <h3 style={{ ...s.subSectionTitle, marginTop: 40 }}>Trade History</h3>
                  <PnlGrid
                    trades={visibleClosed}
                    dark
                    emptyText="No closed trades yet."
                    takenIds={takenIds}
                    onToggleTake={toggleTake}
                  />
                  {!showFullHistory && closedTrades.length > HISTORY_LIMIT && (
                    <div style={{ textAlign: 'center', marginTop: 20 }}>
                      <button onClick={() => setShowFullHistory(true)} style={s.viewHistoryBtn}>
                        View full trade history ({closedTrades.length}) →
                      </button>
                    </div>
                  )}
                </>
              );
            })()}
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div style={s.page}>
      <style>{GLOBAL_STYLE}</style>
      <nav className="tr-nav" style={s.nav}>
        <a href="/trade-room" style={s.logo}>Trade <span style={s.logoAccent}>Room</span></a>
        <a
          href="#unlock-section"
          onClick={(e) => {
            e.preventDefault();
            setMode('login');
            setError('');
            setNotice('');
            document.getElementById('unlock-section')?.scrollIntoView({ behavior: 'smooth' });
          }}
          style={{ color: '#1a6b4a', fontSize: 14, fontWeight: 600, textDecoration: 'none' }}
        >
          Log in
        </a>
      </nav>

      <div className="tr-hero" style={s.hero}>
        <span style={s.eyebrow}>BTCC Trade Room</span>
        <h1 className="hero-h1" style={s.h1}>Follow every trade — wins and losses, tracked in the open</h1>
        <p style={s.sub}>
          I trade live on BTCC and post every call here, good and bad. Sign up through my link, make your
          first trade risk-free, and unlock the full trade room.
        </p>
        <div style={s.ctaRow}>
          <a href={BTCC_REFERRAL_LINK} target="_blank" rel="noopener noreferrer" style={s.ctaPrimary}>
            Sign up on BTCC — first trade risk-free
          </a>
          <a href={BTCC_REFERRAL_LINK} target="_blank" rel="noopener noreferrer" style={s.ctaSecondary}>
            See the offer details →
          </a>
        </div>
        <p style={s.ctaNote}>Already signed up? Enter your BTCC UID below to unlock the Trade Room.</p>
      </div>

      <div style={s.trustBar}>
        <div style={s.trustItem}><span style={s.trustDot} />Wins &amp; losses — both posted</div>
        <div style={s.trustItem}><span style={s.trustDot} />$50 min. deposit to unlock</div>
        <div style={s.trustItem}><span style={s.trustDot} />Free once you qualify</div>
      </div>

      <div style={s.darkSection}>
        <div style={s.darkSectionInner}>
          <div style={s.darkSectionHead}>
            <h2 style={s.darkSectionTitle}>Recent trades</h2>
            <p style={s.darkSectionDesc}>A sample of what's inside the Trade Room.</p>
          </div>
          <OverallStatsBar stats={teaserOverallStats} animate />
          <PnlCarousel trades={teaser} emptyText="No trades published yet — check back soon." />

          <div style={s.unlockWrap} id="unlock-section">
            <div className="tr-unlock-card" style={s.unlockCard}>
              <div style={s.unlockEyebrow}>Get direct access to the Trade Room</div>
              <h3 style={s.unlockHeading}>Sign up to BTCC using my referral link</h3>
              <a href={BTCC_REFERRAL_LINK} target="_blank" rel="noopener noreferrer" className="tr-offer-pill" style={s.offerPill}>
                <div style={s.offerPillTitle}>BTCC</div>
                <div style={s.offerPillSub}>First trade 100% risk-free — see offer details</div>
              </a>
              <p style={s.affiliateDisclosure}>
                None of this is meant to be construed as investment or financial advice — it's for informational
                purposes only. The link above is my BTCC referral link and I receive compensation for signups made through it.
              </p>
              <hr style={s.divider} />

              <h3 style={s.unlockHeading}>
                {mode === 'login' ? 'Log in to your account' : 'Enter your BTCC UID to unlock membership'}
              </h3>

              {error && <div style={s.error}>{error}</div>}

              {mode === 'login' ? (
                <form onSubmit={login}>
                  {notice && <p style={{ ...s.statusBox, background: 'rgba(26,107,74,0.15)', color: '#34d399' }}>{notice}</p>}
                  <label style={s.label} htmlFor="login-email">Email</label>
                  <input
                    id="login-email"
                    className="tr-input"
                    style={s.input}
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                    required
                  />
                  <label style={s.label} htmlFor="login-password">Password</label>
                  <input
                    id="login-password"
                    className="tr-input"
                    style={s.input}
                    type="password"
                    placeholder="Your password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button className="tr-button" style={{ ...s.button, ...(busy ? s.buttonDisabled : {}) }} disabled={busy} type="submit">
                    {busy ? 'Logging in...' : 'Log in'}
                  </button>
                  <p style={s.privacyNote}><a href="/forgot-password" style={{ color: '#9b9b9b' }}>Forgot password?</a></p>
                </form>
              ) : !uidStatus || uidStatus.status !== 'eligible' ? (
                <form onSubmit={checkUid}>
                  <label style={s.label} htmlFor="uid-input">Your BTCC UID</label>
                  <input
                    id="uid-input"
                    className="tr-input"
                    style={s.input}
                    placeholder="e.g. fxhk84"
                    value={uid}
                    onChange={(e) => setUid(e.target.value)}
                    required
                  />
                  <button className="tr-button" style={{ ...s.button, ...(busy ? s.buttonDisabled : {}) }} disabled={busy} type="submit">
                    {busy ? 'Checking...' : 'Check my access'}
                  </button>
                  {uidStatus && (
                    <p style={s.statusBox}>
                      {uidStatus.message}
                      {uidStatus.status === 'already_claimed' && (
                        <> <a href="#login" onClick={(e) => { e.preventDefault(); setMode('login'); setError(''); setNotice(''); }} style={{ color: '#34d399' }}>Log in</a></>
                      )}
                    </p>
                  )}
                </form>
              ) : (
                <form onSubmit={activate}>
                  <p style={{ ...s.statusBox, background: 'rgba(26,107,74,0.15)', color: '#34d399' }}>{uidStatus.message}</p>
                  <label style={s.label} htmlFor="email-input">Email</label>
                  <input
                    id="email-input"
                    className="tr-input"
                    style={s.input}
                    type="email"
                    placeholder="you@example.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <label style={s.label} htmlFor="password-input">Create a password</label>
                  <input
                    id="password-input"
                    className="tr-input"
                    style={s.input}
                    type="password"
                    placeholder="8+ characters"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    minLength={8}
                    required
                  />
                  <button className="tr-button" style={{ ...s.button, ...(busy ? s.buttonDisabled : {}) }} disabled={busy} type="submit">
                    {busy ? 'Activating...' : 'Create account & enter Trade Room'}
                  </button>
                </form>
              )}

              <p style={s.privacyNote}>
                {mode === 'login' ? (
                  <>New here? <a href="#unlock" onClick={(e) => { e.preventDefault(); setMode('unlock'); setError(''); setNotice(''); }} style={{ color: '#34d399' }}>Unlock with your BTCC UID</a></>
                ) : (
                  <>Already have an account? <a href="#login" onClick={(e) => { e.preventDefault(); setMode('login'); setError(''); setNotice(''); }} style={{ color: '#34d399' }}>Log in</a></>
                )}
              </p>
              <p style={s.privacyNote}>We will never spam you or sell your information.</p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
}

const GLOBAL_STYLE = `
  .tr-input:focus { border-color: #1a6b4a !important; box-shadow: 0 0 0 3px rgba(26,107,74,0.12); }
  .tr-button:not(:disabled):hover { opacity: 0.92; }
  .tr-offer-pill:hover { border-color: rgba(26,107,74,0.9) !important; background: rgba(26,107,74,0.16) !important; }
  .pnl-card-bg { animation: pnl-bg-drift 18s ease-in-out infinite alternate; }
  @keyframes pnl-bg-drift {
    0% { transform: scale(1) translateY(0); }
    100% { transform: scale(1.12) translateY(-2%); }
  }
  .pnl-carousel::-webkit-scrollbar { display: none; }
  .pnl-carousel-item:hover { transform: translateY(-4px) scale(1.05); box-shadow: 0 12px 30px rgba(0,0,0,0.5); z-index: 1; }
  @media (max-width: 600px) {
    .hero-h1 { font-size: 30px !important; }
    .tr-hero { padding: 40px 16px 8px !important; }
    .tr-nav { padding: 16px !important; }
    .tr-unlock-card { padding: 28px 20px !important; }
    .tr-overall-hero { padding: 18px 20px !important; flex-basis: 100% !important; }
    .tr-overall-hero-value { font-size: 34px !important; }
  }
`;
